import { STATUS } from "./../constants/general.constant";

import { ROLES } from "../constants/general.constant";

export const UserRoles: string[] = [...Object.values(ROLES)];

export const NonResizableCols = ["action", "Sr_no", "environment"];

export const Environments = [STATUS.SIM, STATUS.LIVE];
